<template>
  <DModal :show-close="false" :isBgOverlay="true" @close="$emit('close')" :appendToBody="true"
          style="z-index: 12312312312312">
    <div class="d-modal text-dark" id="d-create-task-for-user" slot="insertComponent">
      <div class="d-modal__header">
        <h2>{{ user.name }}</h2>
        <div class="font-large icon__bg-circle d-modal__header__close" @click="$emit('close')"><span
          class="icon-cross2"></span>
        </div>
      </div>
      <div class="d-modal__content" :class="{'d-modal__content--no-employments': filteredEmployment.length === 0}">
        <table class="do-table" :class="{'do-table--max-width': !isSalaryIntegrationActive}">
          <thead>
          <th>
            Ansættelse
          </th>
          <th v-if="isSalaryIntegrationActive">Organisation</th>
          <th v-if="isSalaryIntegrationActive">Lønart</th>
          <th v-if="isSalaryIntegrationActive">
            Løbenummer
          </th>
          <th class="center" v-if="filteredEmployment.length !== 0">
            Indberettes som vikarløn
          </th>
          <th v-if="!isSalaryIntegrationActive" class="td--delete"></th>
          </thead>
          <tbody>
          <tr v-if="filteredEmployment.length === 0">
            <td class="text-explainer" style="font-weight: normal">Ingen aktive ansættelser</td>
          </tr>
          <tr
            v-for="employment in filteredEmployment"
            :key="employment.id"
            :class="{'employment--error': employment.v_has_error}">
            <td>{{ employment.title }}</td>
            <template v-if="isSalaryIntegrationActive">
              <td>{{ employment.organisation }}</td>
              <td>
                <input type="number"
                       @change="onChanged(employment, 'default_loenart', employment.default_loenart)"
                       v-model="employment.default_loenart"
                >
              </td>
              <td>
                <input
                  class="input-loebenummer"
                  type="number"
                  @change="onChanged(employment, 'default_loebenummer', employment.default_loebenummer)"
                  v-model="employment.default_loebenummer">
              </td>
              <td
                content='Løbenummer og lønart skal udfyldes '
                v-tippy="{
                arrow: true,
                animateFill: false,
                animation : 'shift-away',
                zIndex: '999999992',
                boundary: 'window',
                onShow: () => !employment.default_loebenummer || !employment.default_loenart
              }">
                <div class="d-input-group--toggler"
                     :class="{'d-input-group--toggler--disabled': !employment.v_has_error && (!employment.default_loebenummer || !employment.default_loenart)}"
                     @click.stop="setIsManualSalary(employment, !employment.manual_salary)">
                  <AppToggle :allowChanges="false" :propOn="employment.manual_salary"></AppToggle>
                </div>
              </td>
            </template>
            <template v-if="!isSalaryIntegrationActive">
              <td>
                <div class="d-input-group--toggler d-input-group--toggler--manual"
                     @click.stop="setIsManualSalary(employment, !employment.manual_salary)">
                  <AppToggle :allowChanges="false" :propOn="employment.manual_salary"></AppToggle>
                </div>
              </td>
              <td class="td--delete">
                <div class="icon__bg-circle icon__bg-circle--danger"
                     @click="setDeleteEmployment(employment)"
                     :content="employment['can_delete?'] ? 'Slet ansættelsen' :  'Arkiver ansættelsen'"
                     v-tippy="{
                arrow: false,
                placement: 'right',
                animateFill: false,
                animation : 'shift-away',
                zIndex: '999999992',
                boundary: 'window'}">
                  <span v-if="employment['can_delete?']" class="icon-bin"></span>
                  <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="tw-icon">
                    <path d="M3.53 2.47a.75.75 0 00-1.06 1.06l18 18a.75.75 0 101.06-1.06l-18-18zM22.676 12.553a11.249 11.249 0 01-2.631 4.31l-3.099-3.099a5.25 5.25 0 00-6.71-6.71L7.759 4.577a11.217 11.217 0 014.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113z" />
                    <path d="M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0115.75 12zM12.53 15.713l-4.243-4.244a3.75 3.75 0 004.243 4.243z" />
                    <path d="M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 00-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 016.75 12z" />
                  </svg>
                </div>
              </td>
            </template>
          </tr>
          </tbody>
        </table>
        <p class="text-link pointer marg-1-top" v-if="user.v_oldEmployments && user.v_oldEmployments.length > 0"
           @click="setIsShowOldEmployment">
          <template v-if="!isShowOldEmployment">Se</template>
          <template v-else>Skjul</template>
          arkiverede ansættelser
        </p>
        <ul v-if="isShowOldEmployment">
          <li v-for="employment in user.v_oldEmployments" class="d-employment-item d-employment-item--deleted">
            {{ employment.title }}
          </li>
        </ul>
      </div>
      <div class="d-modal__footer" v-if="filteredEmployment.length !== 0">
        <button class="do-bttn" @click="$emit('close')">Annuller</button>
        <button class="do-bttn do-bttn--submit" :class="{'do-bttn--submit--loading': isSaving}" @click="saveChanges">
          Gem
        </button>
      </div>
      <DModal v-if="theDeleteEmployment" :showClose="false">
        <div class="d-modal__delete-employment" slot="insertComponent">
          <div class="d-modal__header">
            <h2>Er du sikker?</h2>
            <div class="font-large icon__bg-circle d-modal__header__close" @click="theDeleteEmployment = null"><span
              class="icon-cross2"></span></div>
          </div>
          <div class="d-modal__body">
            <p>Er du sikker på, at du vil du {{ theDeleteEmployment['can_delete?'] ? 'slette' : 'arkivere' }}
              ansættelsen som <b>{{ theDeleteEmployment.title }}</b> for
              <b>{{ user.name }}</b> hos <b>{{ school.name ? school.name : 'docendo' }}</b></p>
            <br>
            <p v-if="theDeleteEmployment['can_delete?']"><i>Bemærk: Ansættelsen har ikke været brugt, og vil derfor
              blive slettet permanent.</i></p>
            <p v-else><i>Bemærk: Ansættelsen har været brugt og vil derfor blive arkiveret, så den ikke kan anvendes
              igen. Tidligere data vil dog ikke blive slettet.</i></p>
            <div class="d-modal__buttons">
              <button class="do-bttn" @click="theDeleteEmployment = null">Annullér</button>
              <button class="do-bttn do-bttn--submit"
                      v-if="theDeleteEmployment['can_delete?']"
                      @click="deleteEmployment(theDeleteEmployment)">Slet ansættelsen
              </button>
              <button class="do-bttn do-bttn--submit"
                      v-if="!theDeleteEmployment['can_delete?'] && theDeleteEmployment['can_archive?']"
                      @click="archiveEmployment(theDeleteEmployment)">
                Arkiver ansættelsen
              </button>
            </div>
          </div>
        </div>
      </DModal>
    </div>
  </DModal>
</template>

<script>
import DModal from '../../common/DModal.vue'
import AppToggle from '../../common/AppToggle.vue'
import docendo from '../../../docendo'
import eventbus from '../../../eventbus'

export default {
  components: {AppToggle, DModal},
  props: {
    user: {
      type: Object
    },
    theEditEmployment: {
      type: Object,
      default: null
    },
    school: {
      type: Object,
      default: null
    },
    isSalaryIntegrationActive: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      theDeleteEmployment: null,
      isShowOldEmployment: false,
      theUpdatingEmployment: null,
      employments: [],
      isSaving: false
    }
  },
  computed: {
    filteredEmployment () {
      return this.theEditEmployment ? this.employments.filter(employment => employment.id === this.theEditEmployment.id) : this.employments
    }
  },
  methods: {
    onChanged (employment) {
      const idx = this.employments.findIndex(emp => emp.id === employment.id)
      if (idx > -1 && this.employments[idx].hasOwnProperty('v_has_error')) {
        this.$delete(this.employments[idx], 'v_has_error')
      }
    },
    setIsManualSalary (employment, bool) {
      const idx = this.employments.findIndex(emp => emp.id === employment.id)
      if (idx > -1) {
        this.employments[idx]['manual_salary'] = bool
        this.onChanged(this.employments[idx])
      }
    },
    setIsShowOldEmployment () {
      this.isShowOldEmployment = !this.isShowOldEmployment
    },
    setDeleteEmployment (employment) {
      this.theDeleteEmployment = employment
    },
    deleteEmployment (employment) {
      const dbObj = {
        schoolId: employment.school_id,
        userId: employment.user_id,
        employmentId: employment.id
      }
      this.$store.dispatch('deleteEmployment', dbObj)
      this.$emit('close')
    },
    archiveEmployment (employment) {
      const dbObj = {
        schoolId: employment.school_id,
        userId: employment.user_id,
        employmentId: employment.id
      }
      this.$store.dispatch('deleteEmployment', dbObj)
      this.$emit('close')
    },
    validate () {
      let isValidated = true
      let errors = []

      if (this.isSalaryIntegrationActive) {
        this.employments.forEach((employment) => {
          if (employment.manual_salary) {
            let missingFields = []

            // Validate default_loenart (only check if it's missing)
            if (
              employment.default_loenart === null ||
              employment.default_loenart === '' ||
              employment.default_loenart === undefined
            ) {
              missingFields.push('Lønart')
            }

            // Validate default_loebenummer (must be between 1-9 or empty)
            if (
              employment.default_loebenummer === null ||
              employment.default_loebenummer === '' ||
              employment.default_loebenummer === undefined
            ) {
              missingFields.push('Løbenummer')
            } else {
              let loebenummerValue = Number(employment.default_loebenummer)
              if (loebenummerValue < 1 || loebenummerValue > 9 || isNaN(loebenummerValue)) {
                errors.push(`Ugyldigt løbenummer for ${employment.name || 'ansat'} – skal være mellem 1 og 9 eller tomt`)
                isValidated = false
                this.$set(employment, 'v_has_error', true)
              }
            }

            // Add missing fields error message
            if (missingFields.length > 0) {
              errors.push(`Manglende ${missingFields.join(' og ')} for ${employment.name || 'ansat'}`)
              isValidated = false
              this.$set(employment, 'v_has_error', true)
            }
          }
        })
      }

      if (!isValidated) {
        eventbus.toast = {
          text: errors.length > 1
            ? `Flere fejl:\n${errors.join('\n')}`
            : errors[0],
          success: false
        }
      }

      return isValidated
    },
    saveChanges () {
      if (!this.validate()) {
        return
      }
      this.isSaving = true
      const numberOfSaves = this.employments.length
      let saves = 0
      this.employments.forEach((employment, key) => {
        const dbObj = {
          schoolId: employment.school_id,
          userId: employment.user_id,
          employmentId: employment.id,
          manualSalary: employment.manual_salary,
          defaultLoenart: employment.default_loenart ? employment.default_loenart * 1 : null,
          defaultLoebenummer: employment.default_loebenummer ? employment.default_loebenummer * 1 : null
        }
        docendo.updateEmployment(dbObj.schoolId, dbObj.userId, dbObj.employmentId, dbObj.manualSalary, dbObj.defaultLoenart, dbObj.defaultLoebenummer, success => {
          saves++
          if (numberOfSaves === saves) {
            this.$store.dispatch('readEmployments')
            this.$emit('close')
          }
        }, failure => {
          console.log('failure!')
        })
      })
    }
  },
  mounted () {
    const employments = JSON.parse(JSON.stringify(this.user.v_employments))
    this.employments = employments.sort((a, b) => a.title.localeCompare(b.title))
  }
}
</script>

<style scoped>
@import "../../../assets/css/variables.css";

.d-modal {
  width: 850px;
  border-radius: 16px;
  position: relative;
}

.d-modal__header {
  margin-bottom: 0;
  text-align: left;
  background: transparent;
  border-bottom: 0;
}

.d-modal__buttons {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.d-modal__content {
  padding: 0 1rem;
}

.d-modal__content.d-modal__content--no-employments {
  padding: 0 1rem 1rem;
}

.d-employment-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 1rem;
  width: 100%;
  background: #fff;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  margin-bottom: 1rem;
  font-weight: bold;
}

.d-employment-item.d-employment-item--deleted {
  background: #eee;
}

.d-tag {
  font-size: .8rem;
  background: #f9fafb;
  padding: 0 0.4rem;
  color: #4b5563;
  border: 1px solid #ebedee;
  border-radius: 4px;
}

.d-tag.d-tag--yellow {
  background: #fefce8;
  border-color: #f4e6c0;
  color: #854d0f;
}

.d-employment-item__right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.d-input-group--toggler {
  display: flex;
  align-items: center;
  gap: 1rem;
  justify-content: space-between;
  padding: 0.5rem;
  margin-right: -0.5rem;
  border-radius: 4px;
  cursor: pointer;
}

.d-input-group--toggler.d-input-group--toggler--disabled {
  pointer-events: none;
  opacity: 0.4;
  cursor: not-allowed;
  background: transparent !important;
}

.d-input-group--toggler.d-input-group--toggler--active > .d-label {
  color: var(--dark-blue);
}

.d-input-group--toggler > .d-label {
  margin-bottom: 0;
  cursor: pointer;
}

.do-table .d-input-group--toggler {
  justify-content: center;
}


.do-spinner__container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 17px;
}

.do-table {
  border: 1px solid #e2e8f0;
  border-width: 0 1px 1px 1px;
  padding: 8px;
  width: 100%;
  background-color: #fff;
  border-collapse: collapse;
}


.do-table thead {
  background: #f6f9fc;
  border: 1px solid #e2e8f0;
  border-width: 1px 0;
  text-transform: uppercase;
  padding: 8px;
  font-weight: 700;
  text-align: left;
  color: #8898aa;
  font-size: 10px;
}

.do-table thead th,
.do-table tbody td {
  padding: 0.5rem 0.5rem;
}

.do-table tbody td:first-child {
  font-weight: bold;
}

.do-table tbody tr:hover {
  background: aliceblue;
}

.do-table tbody tr:not(:first-child) {
  border-top: 1px solid #e2e8f0;
}

.d-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1rem;
}

.employment--error {
  border: 1px solid red;
}

.td--delete {
  width: calc(30px + 1rem);
}

.input-loebenummer {
  width: 80px;
}

</style>



// WEBPACK FOOTER //
// SalarySettingsUsersUser.vue?7e465cbf